module.exports = __webpack_public_path__ + "img/bubble.709904ab.png";